import styled, { css } from 'styled-components';

import { FocusedBox } from '../../form/Button/styles';

export const Box = styled.div`
  padding: 2rem 1rem 1.75rem;
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.05);
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: 700px) {

    height: 11rem;
    border-radius: 8px;
    padding: 1rem;
    
    justify-content: center;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.25rem;
  gap: 18px;

  @media screen and (max-width: 700px) {
    display: grid;
    grid-template-columns: 50px 245px;
    padding: 0 8px;
  }
  @media screen and (max-width: 500px) {
    display: grid;
    grid-template-columns: 50px auto;
    padding: 0 8px;
    gap: 0;
  }
  div {
    width: unset;
  }
`;

export const Info = styled.p`
  word-break: normal;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.base};
  line-height: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 237px;
  height: 58px;
`;

const disabledStyle = css`
  background-color: #cfcfcf;
  border: 2px solid #cfcfcf;
  cursor: not-allowed;

  a{
    color: #515151;
  }
`;

const enabledStyle = css`
  background-color: ${({ subscribed }) => (subscribed ? '#fff' : '#018762')};
  border: 2px solid #018762;

  a{
    color: ${({ subscribed }) => (subscribed ? '#018762' : '#fff')};
  }
`;

export const Button = styled.button`
  ${({ disabled }) => (disabled ? disabledStyle : enabledStyle)}
  display: block;
  text-align: center;
  padding: 10px 0;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 700;

  box-shadow: ${({ shadowy }) => (shadowy ? '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.3)' : 'none')};

  @media (min-width: 701px) and (max-width: 1019px) {
    width: 350px;
  }
`;
